/* @flow */
import * as React from 'react';

import AvatarWithText from 'components/AvatarWithText';
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupName from 'groups/components/GroupName.jsx';

type Props = {
  avatar?: React.Element,
  group: Group | Organization,
  subtextAppend?: React.Element,
};

export default function GroupAvatarWithText({ avatar, group, subtextAppend }: Props) {
  return (
    <AvatarWithText
      title={<GroupName group={group} />}
      avatar={avatar || <GroupAvatar group={group} />}
      subtext={
        <React.Fragment>
          @{group.getCodeOrError()}
          {subtextAppend && <React.Fragment> • {subtextAppend}</React.Fragment>}
        </React.Fragment>
      }
    />
  );
}
